// Iris — Affiche bra_fit / thong_and_garterbelt_fit sous les sélecteurs de taille.
// Écoute l'événement variant:change émis par <variant-picker> (Prestige 11.x).

(function () {
  function bindForm(formId) {
    var form = document.forms[formId];
    if (!form) return;
    var mapEl = document.querySelector('[data-iris-fit-map="' + formId + '"]');
    if (!mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    form.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var fits = map[variant.id];
      var optionValues = [variant.option1, variant.option2, variant.option3];

      document.querySelectorAll('[data-iris-fit][data-form="' + formId + '"]').forEach(function (el) {
        var kind = el.getAttribute('data-iris-fit'); // 'bra' | 'thong'
        var pos = parseInt(el.getAttribute('data-option-position'), 10) || 1;
        var value = fits && fits[kind];
        var textEl = el.querySelector('[data-iris-fit-text]');
        var optionEl = el.querySelector('[data-iris-fit-option]');

        if (value) {
          if (textEl) textEl.innerHTML = value;
          if (optionEl) optionEl.textContent = optionValues[pos - 1] || '';
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
    });
  }

  function init() {
    var seen = new Set();
    document.querySelectorAll('[data-iris-fit-map]').forEach(function (el) {
      var formId = el.getAttribute('data-iris-fit-map');
      if (formId && !seen.has(formId)) {
        seen.add(formId);
        bindForm(formId);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
